"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MessageBox_1 = __importDefault(require("../MessageBox/MessageBox"));
const DefaultFallback = ({ error, errorInfo }) => (react_1.default.createElement(MessageBox_1.default, { title: error.message },
    "This occurred:",
    react_1.default.createElement("ul", null, errorInfo.componentStack
        .split(/\n/)
        .slice(1)
        .map((step) => (react_1.default.createElement("li", { className: "block" }, step))))));
exports.default = DefaultFallback;
